import { ReactNode } from "react";
import { Trans, useTranslation } from "react-i18next";

import { ConsentRequiredModal } from "../controls/consent-control/ConsentRequiredModal";

interface NameMismatchModalProps {
  show: boolean;
  onClose: () => void;
  header?: string;
  bodyContent?: ReactNode;
}

export function NameMismatchModal(props: NameMismatchModalProps) {
  const { show, onClose, header, bodyContent } = props;
  const { t } = useTranslation();

  const resolvedHeader = header ?? t("Name doesn't match your details");
  const resolvedBody = bodyContent ?? (
    <>
      <p>
        {t(
          "The first and last name entered here must match the legal name or any previous/alias names you have declared on your application."
        )}
      </p>
      <p>
        {t("If the name entered in this form is incorrect, please update it.")}
      </p>
      <p>
        <Trans>
          If your document uses a{" "}
          <strong>previous, maiden, or alias name</strong>, add it in the{" "}
          <strong>Previous Names</strong> section on the{" "}
          <strong>Personal Details</strong> page.
        </Trans>
      </p>
    </>
  );

  return (
    <ConsentRequiredModal
      show={show}
      onClose={onClose}
      alternativeDialogContent={{
        header: resolvedHeader,
        content: resolvedBody,
      }}
    />
  );
}
